import React, {useState} from 'react';
import Popup from "../../../../Popap";
import AudioPlayer from "../../../../AudioPlayer";
import VideoPlayer from "../../../../VideoPlayer";
import pdfIcon from '../../../../../img/icon-pdf.png';
import epubIcon from '../../../../../img/icon-ebup.png';
import imgMp from '../../../../../img/icon-mp32.png'
import imgPlay from '../../../../../img/play-button.png'

import '../../ProjectsFiles.scss';

const SubProjectItem = ({projectFile}) => {
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [isAudioPlayerVisible, setAudioPlayerVisible] = useState(false);
    const file = projectFile.file;
    let img = null;
    let fileItemContent;

    const handleButtonClick = () => {
        setPopupVisible(true);
    };

    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = file.file;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleAudioButtonClick = () => {
        setAudioPlayerVisible(!isAudioPlayerVisible);
    };

    if (file.type === "image") {
        img = file.file;
        fileItemContent = (
            <div className="file-item">
                <div className="icon icon-play">
                    <img src={img} alt={file.name}/>
                </div>
                <button onClick={handleButtonClick}>{file.name}</button>
                {isPopupVisible && (
                    <Popup onClose={handleClosePopup} img={img}>

                    </Popup>
                )}
            </div>
        );
    } else if (file.type === "video") {
        if (file.thumbnail_url) {
            img = file.thumbnail_url;
        } else {
            img = imgPlay;
        }
        fileItemContent = (
            <div className="file-item">
                <div className="icon icon-play">
                    <img src={img} alt={file.name}/>
                </div>
                <button onClick={handleButtonClick}>{file.name}</button>
                {isPopupVisible && (
                    <Popup onClose={handleClosePopup}>
                        <VideoPlayer
                            src={file.file}/>
                    </Popup>
                )}
            </div>
        );
    } else if (file.type === "application") {
        if (file.file.endsWith(".pdf")) {
            img = pdfIcon;

        }
        if (file.file.endsWith(".epub")) {
            img = epubIcon;
        }
        fileItemContent = (
            <div className="file-item">
                <a href={file.file} target="_blank" rel="noreferrer">
                    <div className="icon icon-play">
                        <img src={img} alt={file.name}/>
                    </div>
                </a>
                <button onClick={handleDownload}>{file.name}</button>
            </div>
        );
    } else if (file.type === "audio") {
        img = imgMp;
        fileItemContent = (
            <div className="file-item" style={{justifyContent: 'space-between'}}>
                <div className="file-item-wrapper">
                    <div className="icon icon-mp3">
                        <img src={img} alt={file.name}/>
                    </div>
                    <button onClick={handleAudioButtonClick}>{file.name}</button>
                </div>
                {isAudioPlayerVisible && <AudioPlayer src={file.file}/>}
            </div>
        );
    } else {
        fileItemContent = (
            <div className="file-item">
                <div className="icon icon-play">
                    <img src={img} alt={file.name}/>
                </div>
                <button>{file.name}</button>
            </div>
        );
    }

    return fileItemContent;
}

export default SubProjectItem;
